import {IRealityCheckHandler} from "../../session-timer/reality-check/handlers/reality-check-handler.interface";
import {StandardRealityCheckHandler} from "../../session-timer/reality-check/handlers/standard-reality-check-handler";
import {
    MaltaRealityCheckPresenter
} from "../../session-timer/reality-check/presenters/malta/malta.reality-check-presenter";
import {RegulationWithRealityCheck} from "../regulation-with-reality-check";

export class MaltaRegulation extends RegulationWithRealityCheck {

    createRealityCheckHandler(): IRealityCheckHandler {
        return new StandardRealityCheckHandler(this.services, new MaltaRealityCheckPresenter(this.services), {
            requireUserConfirmation: true
        });
    }
}